var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolJsShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.744141 30.2344C0.744141 13.6658 14.1756 0.234375 30.7441 0.234375H90.7441C107.313 0.234375 120.744 13.6658 120.744 30.2344V90.2344C120.744 106.803 107.313 120.234 90.7441 120.234H30.7441C14.1756 120.234 0.744141 106.803 0.744141 90.2344V30.2344Z",
    fill: "url(#paint0_linear_219_4770)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7441 30.2344H30.7441V90.2344H90.7441V30.2344ZM76.6109 80.5334C73.8299 80.5334 72.2575 79.0829 71.0489 77.1096L66.4669 79.7714C68.1221 83.0419 71.505 85.5371 76.7412 85.5371C82.0964 85.5371 86.084 82.7562 86.084 77.6799C86.084 72.9714 83.3794 70.8771 78.5889 68.8228L77.1793 68.2191C74.7603 67.1714 73.7127 66.4867 73.7127 64.7952C73.7127 63.4267 74.7594 62.379 76.4108 62.379C78.0299 62.379 79.0727 63.0619 80.0394 64.7952L84.4298 61.9761C82.5728 58.7094 79.9956 57.4618 76.4108 57.4618C71.3756 57.4618 68.1537 60.6809 68.1537 64.9095C68.1537 69.4999 70.8565 71.6714 74.9251 73.4047L76.3347 74.0095C78.9061 75.1343 80.4394 75.819 80.4394 77.7524C80.4394 79.3657 78.947 80.5334 76.6109 80.5334ZM54.7603 80.4982C52.8232 80.4982 52.0174 79.1697 51.1317 77.5982L46.5422 80.3767C47.8718 83.1905 50.486 85.5267 55.0003 85.5267C59.9966 85.5267 63.4194 82.8695 63.4194 77.0314V57.7839H57.7813V76.9554C57.7813 79.7734 56.6127 80.4982 54.7603 80.4982Z",
    fill: "url(#paint1_linear_219_4770)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4770",
    x1: 60.7441,
    y1: 0.234375,
    x2: 60.7441,
    y2: 120.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4770",
    x1: 60.7441,
    y1: 30.2344,
    x2: 60.7441,
    y2: 90.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolJsShort);
export default __webpack_public_path__ + "static/media/symbol-js-short.f8c63e0cc5b16ac963e7844e53ed6cdc.svg";
export { ForwardRef as ReactComponent };